import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Master Pajak',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Pajak',
        href: '/adm/fin/master/pajak',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'kode_pajak',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'description',
        label: 'Pajak',
        sortable: true,
      },
      {
        key: 'persentase',
        label: 'Persentase',
      },
      {
        key: 'acc_buy_name',
        label: 'Akun Beli',
      },
      {
        key: 'acc_sale_name',
        label: 'Akun Jual',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'kode_pajak',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'description',
        label: 'Pajak',
        sortable: true,
      },
      {
        key: 'persentase',
        label: 'Persentase',
      },
    ],
    detail: false,
    form: {
      kode_pajak: '',
      description: '',
      persentase: '',
      is_for_hpp: false,
      acc_buy: '',
      acc_buy_name: '',
      acc_sale: '',
      acc_sale_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changePajak(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPajak(context, params = null) {
    let result = await ApiGetRequest(`fin/pajak`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPajak({ commit, state }) {
    commit('changePajak', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/pajak`, params);
    commit('changePajak', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailPajak({ commit, state }, payload = null) {
    commit('changePajak', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/pajak/${payload.id}`);
    commit('changePajak', {
      loading: false,
    });

    if (!result.error) {
      commit('changePajak', {
        form: {
          ...state.data.form,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async createPajak({ commit, state, dispatch }) {
    commit('changePajak', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/pajak`, state.data.form);
    commit('changePajak', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePajak({ commit, state, dispatch }, payload = null) {
    commit('changePajak', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/pajak/${payload.id}`,
      state.data.form
    );

    commit('changePajak', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePajak({ commit, dispatch }, payload = null) {
    commit('changePajak', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/pajak/${payload.id}`);
    commit('changePajak', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
